import { useMemo, useContext } from 'react';
import { getOtherPaymentMethods } from '@/utils/paymentMethods';
import { PaymentMethodRow } from '../PaymentMethodRow/PaymentMethodRow';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, type ExcludeOtherPaymentMethod } from '@/types/common';
import { useTranslate } from '@/hooks/useTranslate';
import { Select } from '../Common/Select';
import { cn } from '@/utils/cn';
import { FontAwesomeIcon } from '../Common/FontAwesomeIcon/FontAwesomeIcon';
import { useSelectedPaymentMethod } from '@/hooks/useSelectedPaymentMethod';

export const OtherPaymentForm = () => {
  const {
    paymentMethodsAvailable,
    otherMethodSelected,
    actions: { setPaymentMethodSelected, updateOtherMethodSelected },
  } = useContext(CheckoutContext);
  const otherPaymentMethods = useMemo(() => getOtherPaymentMethods(paymentMethodsAvailable), [paymentMethodsAvailable]);
  const { t } = useTranslate();
  const { selectedPaymentMethod } = useSelectedPaymentMethod();

  const handleBack = () => {
    setPaymentMethodSelected(selectedPaymentMethod as PaymentMethodEnum);
  };

  return (
    <div className="flex flex-col gap-4 pt-4 md:pt-0">
      <div
        data-testid="other-payment-back"
        className="flex flex-row items-center gap-0.5 cursor-pointer"
        onClick={handleBack}
      >
        <div className="text-sm color-card-foreground font-semibold">
          <FontAwesomeIcon icon="fa-regular fa-arrow-left cursor-pointer mr-2" />
          {t('back')}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {otherPaymentMethods.map((pm) => {
          const value = pm.paymentMethodName as ExcludeOtherPaymentMethod;
          const isSelected = otherMethodSelected === value;
          return (
            <Select
              key={value}
              id={value}
              isSelected={isSelected}
              onSelect={() => {
                setPaymentMethodSelected(value as PaymentMethodEnum);
                updateOtherMethodSelected(value);
              }}
              className={cn(isSelected && 'border-selected-border')}
            >
              <PaymentMethodRow paymentMethod={value as PaymentMethodEnum} />
            </Select>
          );
        })}
      </div>
    </div>
  );
};
